'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _escrow = require('./remote/escrow');

var Escrow = {
    completeEscrowDeposit: _escrow.EscrowRemote.completeEscrowDeposit,
    fetchEscrowAccountInfo: _escrow.EscrowRemote.fetchEscrowAccount,
    releaseEscrowDeposit: _escrow.EscrowRemote.releaseEscrowDeposit
};

exports.default = Escrow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/escrow.js
// module id = hIaO
// module chunks = 60